/**
 * applicationEventsService.js
 *
 * API client for the Application Event Log.
 * Uses the shared axios instance from api.js — same pattern as all other services.
 */

import api from './api';

// ---------------------------------------------------------------------------
// Event list
// ---------------------------------------------------------------------------

/**
 * @param {Object} filters
 * @param {number}  [filters.limit=200]
 * @param {string}  [filters.level]          INFO | WARN | ERROR
 * @param {string}  [filters.category]       SIGNING | VERIFICATION | SWITCH_COMM | AUTH | SYSTEM
 * @param {string}  [filters.correlationId]
 * @param {string}  [filters.search]
 * @param {string}  [filters.from]           ISO-8601 datetime
 * @param {string}  [filters.to]             ISO-8601 datetime
 */
export async function fetchEvents(filters = {}) {
  const params = {};
  if (filters.limit)         params.limit         = filters.limit;
  if (filters.level)         params.level         = filters.level;
  if (filters.category)      params.category      = filters.category;
  if (filters.correlationId) params.correlationId = filters.correlationId;
  if (filters.search)        params.search        = filters.search;
  if (filters.from)          params.from          = filters.from;
  if (filters.to)            params.to            = filters.to;

  const response = await api.get('/admin/events', { params });
  return response.data;
}

// ---------------------------------------------------------------------------
// Single event
// ---------------------------------------------------------------------------

export async function fetchEventById(id) {
  const response = await api.get(`/admin/events/${id}`);
  return response.data;
}

// ---------------------------------------------------------------------------
// Stats banner
// ---------------------------------------------------------------------------

export async function fetchEventStats() {
  const response = await api.get('/admin/events/stats');
  return response.data;
}

// ---------------------------------------------------------------------------
// Recent errors (for Dashboard page widget)
// ---------------------------------------------------------------------------

export async function fetchRecentErrors() {
  const response = await api.get('/admin/events/recent-errors');
  return response.data;
}
